export default __webpack_public_path__ + "static/media/headset.ce45368d.svg";